import Vue from 'vue'
import VueRouter from 'vue-router'
import {
  isAuthenticated,
} from '@/auth/sanctum'
import menu from '../navigation/vertical/index'
import arrivalScan from './routes/arrival-scan'
import companies from './routes/companies'
import declarations from './routes/declarations'
import invoicing from './routes/invoicing'
import reports from './routes/reports'
import shipments from './routes/shipments'
import parcels from './routes/parcels'
import carriers from './routes/carriers'
import users from './routes/users'
import warehouses from './routes/warehouses'
import specialcommodities from './routes/specialcommodities'
import customsLog from '@/router/routes/customs_log'
import event from './routes/event'
import permissions from '@/auth/permissions'
import validHsCodes from '@/router/routes/valid_hs_codes'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    ...arrivalScan,
    ...companies,
    ...declarations,
    ...invoicing,
    ...shipments,
    ...parcels,
    ...carriers,
    ...validHsCodes,
    ...specialcommodities,
    ...reports,
    ...users,
    ...warehouses,
    ...customsLog,
    ...event,
    {
      path: '/',
      redirect: () => {
        const item = menu.find(entry => entry.route && permissions.hasPermissionsToMenuItem(entry))
        if (!item) {
          return null
        }
        const route = router.resolve({ name: item.route })
        return route.route.path
      },
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('@/views/dashboard/Index.vue'),
      meta: {
        pageTitle: 'Dashboard',
        permissions: ['view shipment'],
      },
    },
    {
      path: '/ongoing-shipments-dashboard',
      name: 'ongoing-shipments-dashboard',
      component: () => import('@/views/dashboard/OngoingShipmentsStats.vue'),
    },
    {
      path: '/authorizations',
      name: 'authorizations',
      component: () => import('@/views/authorizations/Authorizations.vue'),
      meta: {
        pageTitle: 'Authorizations',
        breadcrumb: [
          {
            text: 'Authorizations',
            active: true,
          },
        ],
      },
    },
    {
      path: '/accept-invitation',
      name: 'accept-invitation',
      component: () => import('@/views/users/invite/Accept.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Auth/Login.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: () => import('@/views/Auth/ForgotPassword.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: () => import('@/views/Auth/ResetPassword.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
  ],
})

// GOOD
router.beforeEach((to, from, next) => {
  const allowedPages = ['login', 'forgot-password', 'register', 'reset-password', 'accept-invitation']

  // Store the intended destination before redirecting to login
  if (!allowedPages.includes(to.name) && !isAuthenticated()) {
    next({
      name: 'login',
      query: { redirect: to.fullPath }, // Save the target URL in the query parameter
    })
  } else if (to.name !== 'accept-invitation' && allowedPages.includes(to.name) && isAuthenticated()) {
    next('/')
  } else {
    if (to.meta.roles) {
      const hasRole = permissions.hasAnyRole(to.meta.roles)
      if (!hasRole) {
        next({ path: '/403' })
        return
      }
    }
    if (to.meta.permissions) {
      const hasPermission = to.meta.permissions.some(permission => permissions.hasPermission(permission))
      if (!hasPermission) {
        next({ path: '/403' })
        return
      }
    }
    next()
  }
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
